module.exports = __webpack_public_path__ + "static/media/Raleway-Italic-VariableFont_wght.676edc6d.ttf";